import { useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  FETCH_TVL_BEGIN,
  FETCH_TVL_SUCCESS,
  FETCH_TVL_FAILURE,
} from "./constants";
import { MultiCall } from "eth-multicall";
import { apiUrl } from "../../configure";
import _ from "lodash";
import { useAuth } from "./auth";
import axios from "axios";
export function fetchDashboard({ token }, logout) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: FETCH_TVL_BEGIN,
      });
      // let dailyResult = await axios.get(apiUrl + "stats/daily/all");
      let result = await axios.get(apiUrl + "client/stats?token=" + token);

      let output = result.data;
      // output.daily = dailyResult.data;
      console.log(output);
      dispatch({
        type: FETCH_TVL_SUCCESS,
        data: output,
      });
    } catch (err) {
      if (_.get(err, "response.status") == 401) {
        logout();
      }
      dispatch({
        type: FETCH_TVL_FAILURE,
      });
      console.log(err);
    }
  };
}

export function useFetchDashboard() {
  const dispatch = useDispatch();

  const { data, fetchDashboardPending, fetchDashboardDone } = useSelector(
    (state) => ({
      data: state.home.data,
      fetchDashboardPending: state.home.fetchDashboardPending,
      fetchDashboardDone: state.home.fetchDashboardDone,
    }),
    shallowEqual
  );
  const { logout } = useAuth();
  const boundAction = useCallback(
    (data) => {
      return dispatch(fetchDashboard(data, logout));
    },
    [dispatch]
  );

  return {
    data,
    fetchDashboard: boundAction,
    fetchDashboardDone,
    fetchDashboardPending,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FETCH_TVL_BEGIN:
      return {
        ...state,
        fetchDashboardPending: true,
      };

    case FETCH_TVL_SUCCESS:
      return {
        ...state,
        data: action.data,
        fetchDashboardDone: true,
        fetchDashboardPending: false,
      };

    case FETCH_TVL_FAILURE:
      return {
        ...state,
        fetchDashboardPending: false,
      };

    default:
      return state;
  }
}
